module.exports = __webpack_public_path__ + "static/media/detail_0046_t.c54d34a8.jpg";